import { FF_C4C_HIDE_PATIENT_PHONE_NUMBER } from '@/constants/featureFlags';
import { getAuthData } from '@/data/service/authService';
import { useFeatureFlags } from './flags';

const UNMASKED_NUMBERS_COUNT = 3;

const maskPhoneNumber = (phoneNumber: string) => {
  const sanitisedPhoneNumber = phoneNumber.replace(/\D/g, '');

  if (!phoneNumber || sanitisedPhoneNumber.length < UNMASKED_NUMBERS_COUNT) {
    return phoneNumber;
  }

  const maskedNumbers = '*'.repeat(sanitisedPhoneNumber.length - UNMASKED_NUMBERS_COUNT);
  const unmaskedNumbers = sanitisedPhoneNumber.slice(-UNMASKED_NUMBERS_COUNT);

  return `${maskedNumbers}${unmaskedNumbers}`;
};

export const usePatientPhoneNumber = () => {
  const { flags } = useFeatureFlags();
  const { isNurse, isDoc } = getAuthData();
  const ffHidePatientPhoneNumber = flags[FF_C4C_HIDE_PATIENT_PHONE_NUMBER];
  const shouldDisplayPatientPhoneNumber = ffHidePatientPhoneNumber ? !isDoc && !isNurse : true;

  return {
    shouldDisplayPatientPhoneNumber,
    maskPhoneNumber
  };
};
